const swiftBeneficiaryComponentStyle = {
	
};

export default swiftBeneficiaryComponentStyle;
